import propTypes from 'prop-types';
import AlertModal from 'components/AlertModal/AlertModal'
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog'
import PublishUpdateModal from './PublishUpdateModal/PublishUpdateModal'
import ResourceConflictModal from './ResourceConflictModal/ResourceConflictModal';
import OverlappingModal from 'components/OverlapsingModal/OverlapsingModal';
import { useSelector } from 'react-redux';
import useScheduleActions from '../hooks/useScheduleActions';
import { useCallback } from 'react';

const ScheduleModals = ({
  openSnackbar,
  openModal,
}) => {
  const {
    remove,
    info,
    conflict,
    overlapping,
    publish,
    update,
    reconcile,
  } = useSelector((store) => store.modals.modals)

  const {
    publishVisible,
    updatePublishVisible,
    reconcileVisible,
  } = useScheduleActions();
  
  const showSnackbar = useCallback((...args) => {
    if (openSnackbar) openSnackbar(...args)
  }, [openSnackbar])

  const onPublish = useCallback((notifyWorkerIds) => (
    publishVisible(notifyWorkerIds, publish?.data?.ids)
      .then(() => showSnackbar('success', 'Schedule published successfully'))
      .catch(() => showSnackbar('error', 'Error during publish'))
    ),
    [publishVisible, showSnackbar, publish?.data?.ids]
  );

  const onUpdatePublish = useCallback((notifyWorkerIds) => (
    updatePublishVisible(notifyWorkerIds, update?.data?.ids)
      .then(() => showSnackbar('success', 'Schedule updated successfully'))
      .catch(() => showSnackbar('error', 'Error during update'))
    ),
    [updatePublishVisible, showSnackbar, update?.data?.ids]
  );

  const onReconcile = useCallback(() =>
    reconcileVisible({
      onSuccess: () => {
        showSnackbar('success', 'Schedule reconciled successfully');
        reconcile?.onClose?.();
      },
      onError: () => showSnackbar('error', 'Error during reconcile'),
    }).catch(() => showSnackbar('error', 'Error during reconcile')
  ), [reconcileVisible, showSnackbar, reconcile]);

  return (
    <>
      {remove?.open ? (
        <ConfirmDialog
          isOpen={remove.open}
          onClose={remove.onClose}
          onSubmit={remove.onSubmit}
          text={remove.data?.text || remove.data}
          loadingOnSubmit
        />
      ) : null}
      {info?.open ? (
        <AlertModal
          isOpen={info.open}
          info={info.data}
          onClose={info.onClose}
        />
      ) : null}
      {update?.open ? (
        <PublishUpdateModal
          isOpen={update.open}
          onClose={update.onClose}
          onSubmit={onUpdatePublish || update.onSubmit}
          data={update.data}
          openSnackbar={openSnackbar}
        />
      ) : null}
      {publish?.open ? (
        <PublishUpdateModal
          isOpen={publish.open}
          onClose={publish.onClose}
          onSubmit={onPublish || publish.onSubmit}
          data={publish.data}
          openSnackbar={openSnackbar}
        />
      ) : null}
      {reconcile?.open ? (
        <ConfirmDialog
          isOpen={reconcile.open}
          onClose={reconcile.onClose}
          onSubmit={onReconcile || reconcile.onSubmit}
          text={reconcile.data?.text || reconcile.data}
          loadingOnSubmit
        />
      ) : null}
      {conflict?.open ? (
        <ResourceConflictModal
          data={conflict.data?.data || conflict.data}
          errorData={conflict?.data.errorData}
          closeModal={conflict.onClose}
          openModal={openModal}
        />
      ) : null}
      {overlapping?.open ? (
        <OverlappingModal
          data={overlapping.data?.data}
          message={overlapping.data.reason}
          onClose={overlapping.onClose}
          onSave={overlapping.onSubmit}
          moveFrom={overlapping.data?.moveFrom}
        />
      ) : null}
    </>
  )
}

ScheduleModals.propTypes = {
  openSnackbar: propTypes.func.isRequired,
  openModal: propTypes.func.isRequired,
}

export default ScheduleModals;